/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import Breadcrumb from "../../../../component/breadcrumb";
import ManageCustomersHierarchy from "../../manageCustomers/manageCustomersHierarchy";
import { withTranslation } from "react-i18next";
import { Card, Grid, Chip } from "@mui/material";
import Button from "../../../../component/button";
import { UsersIcon } from "../../../../component/icons/icons";
import { withNavigation } from "../../../../helper/withNavigation";
import ButtonGroup from "@mui/material/ButtonGroup";
import { DetailView, ListView } from "../../../../component/icons/icons";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import Loader from "../../../../component/loader";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import { ViewIconNew, DownloadIcon, ClearIcon, SearchIcon, AdvanceSearchIcon } from "../../../../component/icons/icons";
import { useState, useEffect } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Pagination from "@mui/material/Pagination";
import currencyFormatter from "../../../../helper/currencyFormatter";
import { formatDate } from "../../../../helper/dateFormatter";
import { formatNumber } from "../../../../helper/numberFormatter";
import Base64ViewerDialog from "../../../../component/fileViewer";
import classes from "../../../../pages/sales/addonsManagement/addons.module.css";
import Input from "../../../../component/inputpm";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import moment from "moment";
// Manage order page class
class Billing extends Component {
  // Declare property values that belongs to the component
  state = {
    bread: [{ title: this.props.t("BILLING_ACCOUNTS"), url: "/billing" }],
    display: false,
    isMobile: false,
    showCustomerList: false,
    billingView: 'detail',
    loading: false,
    billingList: [],
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalCount: 0,
    sortBy: "invoiceDate",
    sortOrder: "DESC",
    billingSearchFilters: {
      invoiceId: "",
      orderId: "",
      customerName: "",
      customerBan: "",
      amount: "",
      status: "",
      fromDate: "",
      toDate: "",
    },
    billingView: 'detail',
    today: moment(new Date()).format("yyyy-MM-DD"),
    showAdvanceSearch: false,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    this.props.setCompDidMount();
    let search = new URLSearchParams(this.props.router.location.search);
    let orderId = search.get("orderId");
    let userId = search.get("userId");
    let billingView = localStorage.getItem('billingView');
    if (billingView) {
      this.setState({ billingView: billingView });
    } else {
      this.setState({ billingView: 'detail' });
    }
    this.setState(
      {
        orderId: orderId,
        userId: userId,
      },
      () => {
        this.setState({ display: true });
        if (this.state.billingView === 'list') {
          this.getAllBillingList();
        }
      },
    );
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };

  toggleShowAllBilling = (view) => {
    if (this.state.billingView === view) {
      return;
    }
    this.setState({ billingView: view }, () => {
      localStorage.setItem('billingView', view);
      if (view === 'list') {
        this.getAllBillingList();
      }
    });
  };

  getAllBillingList = () => {
    console.log('getAllBillingList');
    this.setState({ loading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    let url = `${constants.busV4Url}/bills?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}`;
    if (this.state.billingSearchFilters.invoiceId) {
      url += `&billId=${this.state.billingSearchFilters.invoiceId}`;
    }
    if (this.state.billingSearchFilters.orderId) {
      url += `&orderId=${this.state.billingSearchFilters.orderId}`;
    }
    if (this.state.billingSearchFilters.customerName) {
      url += `&customerName=${this.state.billingSearchFilters.customerName}`;
    }
    if (this.state.billingSearchFilters.customerBan) {
      url += `&customerId=${this.state.billingSearchFilters.customerBan}`;
    }
    if (this.state.billingSearchFilters.amount) {
      url += `&amount=${this.state.billingSearchFilters.amount}`;
    }
    if (this.state.billingSearchFilters.status) {
      url += `&status=${this.state.billingSearchFilters.status}`;
    }
    if (this.state.billingSearchFilters.fromDate) {
        let fromDate = this.state.billingSearchFilters.fromDate
        ? encodeURIComponent(this.convertDateParam(this.state.billingSearchFilters.fromDate))
        : "";
      url += `&from=${fromDate}`;
    }
    if (this.state.billingSearchFilters.toDate) {
      let toDate = this.state.billingSearchFilters.toDate
        ? encodeURIComponent(this.convertTillDateParam(this.state.billingSearchFilters.toDate))
        : "";
      url += `&to=${toDate}`;
    }
    BusApiCall('GET', url, {}, pageOptions).then(res => {
      console.log('res', res);
      this.setState({ 
        billingList: res.data.invoiceHistory, 
        totalCount: +res.headers["x-total-count"],
        loading: false,
      });
    }).catch(err => {
      console.log('err', err);
      if (err.response && err.response.data && err.response.data.message) {
        this.props.setErrorMessage(err.response.data.message, false);
      } else {
        this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false);
      }
      this.setState({ loading: false });
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      { page: 1, rowsPerPage: event.target.value, startRecord: 1 },
      () => this.getAllBillingList()
    );
  };

  handleChangePage = (event, value) => {
    this.setState(
      { page: value, startRecord: (value - 1) * this.state.rowsPerPage + 1 },
      () => this.getAllBillingList()
    );
  };

  base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  };

  downloadInvoicePdf = (orderId, invoiceId, type) => {
    this.setState({
      loading: true,
    });
    console.log('downloadInvoicePdf', orderId, invoiceId, type);  
    // Get PDF link
    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders/${orderId}/invoice/${invoiceId}`,
    )
      .then((res) => {
        this.setState({
          loading: false,
        });
        console.log("check original response", res.data);

        if (type && type === "view") {
          console.log('view block')
          this.setState({
            selectedFileToView: {
              base64: res.data.invoicePdf,
              mimeType: "application/pdf",
              name: invoiceId,
            },
            showFileData: true,
          });
        } else {
          // Convert pdf to array buffer
          console.log('download block')
          var arrrayBuffer = this.base64ToArrayBuffer(res.data.invoicePdf);
          // Create pdf blob
          var blob = new Blob(
            [arrrayBuffer],
            { type: "application/pdf" },
            invoiceId + "-bill.pdf",
          );
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement("a");
          link.href = url;
          link.download = invoiceId + "-bill.pdf";
          link.dispatchEvent(new MouseEvent("click"));
          // Create URL object and download
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  initiateInvoicePayment = (orderId, invoiceId) => {
    this.setState({
      invoiceOrderId: orderId,
      invoiceId: invoiceId,
      initiatePaymentDialog: true,
    });
  };
  handleChangeBillingSearchFilters = (e) => {
    this.setState({
      billingSearchFilters: {
        ...this.state.billingSearchFilters,
        [e.target.name]: e.target.value,
      },
    });
  };
  onSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.filterBillingTable();
    }
  };
  filterBillingTable = () => {
    this.getAllBillingList();
  };
  clearBillingFilters = () => {
    this.setState({
      billingSearchFilters: {
        invoiceId: "",
        orderId: "",
        customerName: "",
        customerBan: "",
        amount: "",
        status: "",
        fromDate: "",
        toDate: "",
      },
    });
    this.getAllBillingList();
  };
  toggleAdvanceSearch = () => {
    this.setState({ showAdvanceSearch: !this.state.showAdvanceSearch });
  };
  convertDateParam(date) {
    return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  }

  convertTillDateParam(date) {
    return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  }
  // Render order view
  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              {isMobile && (
                <Grid
                  item
                  style={{ textAlign: "right" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <Button
                    className="buttonSecondary"
                    onClick={this.toggleShowCustomerList}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <UsersIcon />
                    </span>
                    {t("SHOW_CUSTOMER_LIST")}
                  </Button> 
                </Grid>
              )}
              {/* <Grid item xs={6} align={'right'}>
                                <Button
                                    onClick={
                                        () => {
                                            this.hierarchyRef.showAddAdjustment();
                                        }
                                    } >
                                        <span style={{marginRight: '.25rem', verticalAlign: 'middle'}}>
                                        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z" fill="currentColor"/>
                                        </svg>
                                        </span>
                                    {this.props.t('NEW_SUBSCRIPTION_ADJUSTMENT')}
                                </Button>
                            </Grid> */}
            </Grid>
          </div>
        </div>
        <main>
        <Grid container spacing={1}>
            <Grid
              item
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "flex-end",
                marginBottom: "1rem",
              }}
              size={{
                xs: 12,
                md: 12,
              }}
            >
              <ButtonGroup variant="outlined">
                {/* DETAIL VIEW button */}
                <span
                  className={`buttonGroup ${this.state.billingView === 'detail' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllBilling("detail")}
                  style={{
                    backgroundColor: this.state.billingView === 'detail'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.billingView === 'detail' ? "white" : "inherit",
                  }}
                >
                  <span style={{ marginRight: ".4rem" }}>
                    {this.props.t("DETAIL_VIEW")}
                  </span>
                  <DetailView />
                </span>
                {/* LIST VIEW button */}
                <span
                  className={`buttonGroup ${this.state.billingView === 'list' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllBilling("list")}
                  style={{
                    backgroundColor: this.state.billingView === 'list'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.billingView === 'list' ? "white" : "inherit",
                  }}
                >
                  <span>{this.props.t("LIST_VIEW")}</span>
                  <ListView />
                </span>
              </ButtonGroup>
            </Grid>
          </Grid>
          {this.state.loading && <Loader loading={this.state.loading} />}
          {this.state.display && (
            this.state.billingView === 'detail' ? (
            <ManageCustomersHierarchy
              screen="billing"
              orderId={this.state.orderId}
              userId={this.state.userId}
              onRef={(ref) => (this.hierarchyRef = ref)}
              isMobile={isMobile}
              showCustomerList={showCustomerList}
              toggleShowCustomerList={this.toggleShowCustomerList}
            />
            ) : (
              <BillingListView
                billingList={this.state.billingList}
                t={this.props.t}
                totalCount={this.state.totalCount}
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                handleChangePage={this.handleChangePage}
                loading={this.state.loading}
                downloadInvoicePdf={this.downloadInvoicePdf}
                initiateInvoicePayment={this.initiateInvoicePayment}
                viewInvoice={this.viewInvoice}
                billingSearchFilters={this.state.billingSearchFilters}
                handleChangeBillingSearchFilters={this.handleChangeBillingSearchFilters}
                onSearchKeyDown={this.onSearchKeyDown}
                filterBillingTable={this.filterBillingTable}
                clearBillingFilters={this.clearBillingFilters}
                toggleAdvanceSearch={this.toggleAdvanceSearch}
                showAdvanceSearch={this.state.showAdvanceSearch}
                convertDateParam={this.convertDateParam}
                convertTillDateParam={this.convertTillDateParam}
              />
            )
          )}
          {this.state.showFileData && (
            <Base64ViewerDialog
              base64={this.state.selectedFileToView?.base64}
              mimeType={this.state.selectedFileToView?.mimeType}
              title={this.state.selectedFileToView?.name}
              open={this.state.showFileData}
              onClose={() => {
                this.setState({ showFileData: false, selectedFileToView: {} });
              }}
            />
          )}
        </main>
      </div>
    );
  }
}

const BillingListView = (props) => {
  const [paymentModuleActive, setPaymentModuleActive] = useState(false);
  useEffect(() => {
    var modules = JSON.parse(localStorage.getItem("modules"));
    if (modules && modules.module_payment === "enabled") {
      setPaymentModuleActive(true);
    } else {
      setPaymentModuleActive(false);
    }
  }, []);

  const t = props.t;
  return (
    <>
    {!props.loading && (
    <>
      <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
          <div
              className={classes.searchOuterDiv}
              style={{
                marginBottom: ".5rem",
                width: "100%",
                alignItems: "center",
              }}
            >
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("INVOICE_NO")}
                    value={props.billingSearchFilters.invoiceId}
                    name={"invoiceId"}
                    onChange={(e) => {
                      props.handleChangeBillingSearchFilters(e);
                    }}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  />
                </div>
                <div className={classes.searchInputDiv}>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("ORDER_ID")}
                    value={props.billingSearchFilters.orderId}
                    name={"orderId"}
                    onChange={(e) => {
                      props.handleChangeBillingSearchFilters(e);
                    }}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  />
                </div>
                <div className={classes.searchInputDiv}>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("CUSTOMER_NAME")}
                    value={props.billingSearchFilters.customerName}
                    name={"customerName"}
                    onChange={(e) => {
                      props.handleChangeBillingSearchFilters(e);
                    }}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  />
                </div>
                {/* <div className={classes.searchInputDiv}>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("AMOUNT")}
                    value={props.billingSearchFilters.amount}
                    name={"amount"}
                    onChange={(e) => {
                      props.handleChangeBillingSearchFilters(e);
                    }}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  />
                </div> */}
                {/* <div className={classes.searchInputDiv}>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("STATUS")}
                    value={props.billingSearchFilters.status}
                    name={"status"}
                    onChange={(e) => {
                      props.handleChangeBillingSearchFilters(e);
                    }}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  />
                </div> */}
                
                <div
                className={classes.searchOrderLabelOuter}
                style={{ marginTop: ".25rem" }}
              >
                <div className={classes.searchOrderLabelInner}>
                  <Tooltip title={t("SEARCH")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={props.filterBillingTable}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>{" "}
                  &nbsp;
                  <Tooltip title={t("CLEAR")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={props.clearBillingFilters}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                  &nbsp;
                    <Tooltip title={t('ADVANCE_SEARCH')}>
                      <IconButton className='iconButtonSecondary' onClick={() => props.toggleAdvanceSearch()}>
                        <AdvanceSearchIcon />
                      </IconButton>
                    </Tooltip>
                </div>
                </div>
                  {props.showAdvanceSearch && (
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      style={{
                        borderTop: props.showAdvanceSearch
                          ? ".5px solid lightgrey"
                          : "none",
                        marginLeft: 0,
                        marginRight: 0,
                        // marginTop: ".5rem",
                        width: "100%",
                        justifyContent: "flex-end",
                        paddingTop: ".5rem",
                        gap: "1rem",
                      }}
                    >
                      <>
                      <div className={classes.searchInputDiv}>
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          placeholder={t("CUSTOMER_BAN")}
                          value={props.billingSearchFilters.customerBan}
                          name={"customerBan"}
                          onChange={(e) => {
                            props.handleChangeBillingSearchFilters(e);
                          }}
                          onKeyDown={(e) => {
                            props.onSearchKeyDown(e);
                          }}
                        />
                      </div>
                      <div className={classes.searchInputDiv}>
                      <TextField
                                    name="fromDate"
                                    id="searchFromDate"
                                    type="date"
                                    value={props.billingSearchFilters.fromDate}
                                    label={t("FROM_DATE")}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    variant={"outlined"}
                                    size={"small"}
                                    onChange={(e) => {
                                      props.handleChangeBillingSearchFilters(e);
                                    }}
                                    onKeyDown={(e) => {
                                      props.onSearchKeyDown(e);
                                    }}
                                    inputProps={{ max: props.billingSearchFilters.toDate, format: "MM/dd/yyyy" }}
                                    style={{ width: '120px' }}
                                  // className={classes.dateInputClass}
                                  />
                      </div>
                      <div className={classes.searchInputDiv}>
                      <TextField
                                    name="toDate"
                                    id="searchToDate"
                                    type="date"
                                    value={props.billingSearchFilters.toDate}
                                    label={t("TO_DATE")}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    variant={"outlined"}
                                    size={"small"}
                                    onChange={(e) => {
                                      props.handleChangeBillingSearchFilters(e);
                                    }}
                                    onKeyDown={(e) => {
                                      props.onSearchKeyDown(e);
                                    }}
                                    inputProps={{ min: props.billingSearchFilters.fromDate, max: props.today, format: "MM/dd/yyyy" }}
                                    style={{ width: '120px' }}
                                  // className={classes.dateInputClass}
                                  />
                    </div>
                      </>
                    </Grid>
                  )}
            </div>
      </div>
      <Card variant="outlined" className={"roundCorners"}>
      {props.billingList.length > 0 ? (
      <TableContainer>
        <Table className="newGlobalTable" aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>{t("INVOICE_NO")}</TableCell>
              <TableCell>{t("ORDER_ID")}</TableCell>
              <TableCell>{t("CUSTOMER_NAME")}</TableCell>
              <TableCell>{t("DATE")}</TableCell>
              <TableCell>{t("AMOUNT")}</TableCell>
              <TableCell>{t("INVOICE_STATUS")}</TableCell>
              <TableCell>{t("ACTIONS")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.billingList.map((bill) => (
              <TableRow key={bill.invoiceId}>
                <TableCell>{bill.invoiceId}</TableCell>
                <TableCell>{bill.orderId}</TableCell>
                <TableCell>{bill.customerName}</TableCell>
                <TableCell>{formatDate(bill.invoiceDate)}</TableCell>
                <TableCell>{currencyFormatter(bill.totalInvoiceAmount)}</TableCell>
                <TableCell>
                  <Chip
                    size="normal"
                    className={
                      bill.status === "Paid"
                        ? "successChip"
                        : bill.status === "Unpaid"
                          ? "errorChip"
                          : "inProgressChip"
                    }
                    label={bill.status}
                  />
                </TableCell>
                <TableCell style={{}}>
                                  <Tooltip title={t("VIEW")}>
                                    <span style={{ marginRight: 10 }}>
                                      <Button
                                        className={
                                          "buttonSecondary" +
                                          " " +
                                          "iconButtonSecondary"
                                        }
                                        onClick={() => {
                                          props.downloadInvoicePdf(
                                            bill.orderId,
                                            bill.invoiceId,
                                            "view",
                                          );
                                        }}
                                      >
                                        <ViewIconNew />
                                      </Button>
                                    </span>
                                  </Tooltip>
                                  {bill.status === "Unpaid" &&
                                    paymentModuleActive && (
                                      <Tooltip title={t("PAY_INVOICE")}>
                                        <Button
                                          className={"smallButton"}
                                          onClick={() => {
                                            props.initiateInvoicePayment(
                                              bill.orderId,
                                              bill.invoiceId,
                                            );
                                          }}
                                        >
                                          {t("PAY_INVOICE")}
                                        </Button>
                                      </Tooltip>
                                    )}
                                  <Tooltip title={t("DOWNLOAD")}>
                                    <Button
                                      className={
                                        "buttonSecondary" +
                                        " " +
                                        "iconButtonSecondary"
                                      }
                                      onClick={() => {
                                        props.downloadInvoicePdf(
                                          bill.orderId,
                                          bill.invoiceId,
                                          "download",
                                        );
                                      }}
                                    >
                                      <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M6 1C6.27614 1 6.5 1.22386 6.5 1.5V7.29289L8.64645 5.14645C8.84171 4.95118 9.15829 4.95118 9.35355 5.14645C9.54882 5.34171 9.54882 5.65829 9.35355 5.85355L6.35355 8.85355C6.15829 9.04882 5.84171 9.04882 5.64645 8.85355L2.64645 5.85355C2.45118 5.65829 2.45118 5.34171 2.64645 5.14645C2.84171 4.95118 3.15829 4.95118 3.35355 5.14645L5.5 7.29289V1.5C5.5 1.22386 5.72386 1 6 1ZM1 10.5C1 10.2239 1.22386 10 1.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H1.5C1.22386 11 1 10.7761 1 10.5Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </Button>
                                  </Tooltip>
                                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      ) : (
        <TableContainer>
          <Table className="newGlobalTable" aria-label="simple table">
            <TableBody>
              <TableRow>
                <TableCell colSpan={7}>{props.t("NO_DATA_FOUND")}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {props.totalCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {props.t("TOTAL_RECORDS")}:{" "}
            {formatNumber(props.totalCount)}
          </label>
          <label>
            {/* Rows per page select */}
            {props.t("ROWS_PER_PAGE")}
            <Select
              value={props.rowsPerPage}
              onChange={
                props.handleChangeRowsPerPage
              }
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          {/* Pagination component */}
          <Pagination
            count={Math.ceil(
              props.totalCount /
              props.rowsPerPage,
            )}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
      </Card>
      </>
    )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Billing)));
